// Remove once it's possible to add "cascading.variables" as watch targets.
import { Store } from "../interfaces/Store.interface";
import { getValue } from "./getValue";
import { send } from "./send";

export function setItemValue(key: string, store: Store, value: any) {
    const item = getValue(key, store);
    item.value = value;
    send({ [key]: item }, { store, batch: true });
}
